import { RouterView } from "vue-router";
import { EarlyRouting } from "./early/early.routing";

export const RiskConfigRouting = {
    path: "/risk-config",
    name: "risk-config",
    redirect: "/risk-config/early/list",
    component: RouterView,
    meta: { title: "风控管理", icon: "zhiliang" },
    children: [...EarlyRouting],
};
  